import { getListingStatus, getSnapshotListing } from '../api';
import * as TYPES from './types';
import { checkSoldHousePreview } from '@/common/utils';
import { usePageStore } from '@/store';
export default {
//  set up  listingStatus  the value of 
    [TYPES.SET_LISTING_STATUS](payload = []) {
        this.listingStatus = [...payload];
    },
    //  set up  listing  the value of 
    [TYPES.SET_LISTING](payload = []) {
        this.listing = [...payload];
    },

    //  set up  currentListingStatus  the value of 
    [TYPES.SET_CURRENT_LISTING_STATUS](payload = {}) {
        this.currentListingStatus = payload.data;
    },
    //  set up  currentListingStatus  the value of 
    [TYPES.SET_FETCH_LISTING_STATUS](payload = {}) {
        this.fetchListingStatus = payload.data;
    },
    [TYPES.SET_CURRENT_LISTING_NAME](payload = {}) {
        this.currentListingStatusName = payload.data;
    },
    [TYPES.SET_SEARCH_PARAMS](payload = {}) {
        this.searchParams = { ...payload };
    },
    [TYPES.SET_SHOW_THIS_MODULE](payload = true) {
        this.showThisModule = payload;
    },
    //  Set the total number of pages for pagination 
    [TYPES.SET_TOTAL_PAGE](payload = {}) {
        this.totalPage = payload;
    },
    //  set current page 
    [TYPES.SET_PAGE_NUM](payload = {}) {
        this.pageNum = payload.data;
    },
    //  whether to display sold listing price
    // [TYPES.SET_SHOW_SOLD_LISTING_PRICE]( payload = {}) {
    //     this.showSoldPrice = payload.data;
    // },
    //  whether to display listing price
    [TYPES.SET_SHOW_LISTING_PRICE](payload = {}) {
        this.showListingPrice = payload.data;
    },
    [TYPES.SET_HAS_LOCATION](payload = {}) {
        this.hasLocation = payload.data;
    },
    //  Sold listing information 
    [TYPES.SET_SOLD_LISTING_INFO](payload = {}) {
        this.soldListingInfo = payload.data;
    },
    [TYPES.SET_HAS_FETCH_LISITNG_STATUS](payload = true) {
        this.hasFetchListingStatus = payload
    },

    //  Obtained from the backend interface  listing status  and assign 
    async [TYPES.GET_LISTING_STATUS](payload = {}) {
        let ret = await getListingStatus.call(this, payload.data);
        this[TYPES.SET_LISTING_STATUS](ret.data);
    },
    //  Obtained from the backend interface  listing  and assign 
    async [TYPES.GET_LISTING](payload = {}) {
        const pageStore = usePageStore(this.$pinia);
        const params = payload.data || {};
        params.listingSource && delete params.listingSource;
        let page = pageStore.page || {};
        let ret = await getSnapshotListing.call(this, params, page);
        this[TYPES.SET_LISTING](ret.listings);
        //  set pagination 
        this[TYPES.SET_TOTAL_PAGE](ret.totalPage);
        //  Complementary map 
        return this[TYPES.ADD_SOLD_PICTURE]();
    },
    // add picture
    async [TYPES.ADD_SOLD_PICTURE]() {
        const { listing } = this;
        await checkSoldHousePreview({ listings: listing });
    }
};
